// src/components/Snackbar/NewImplementations/ColorAlert/ColorAlert.jsx
import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Slide from '@material-ui/core/Slide'
import styles from './styles.module.css'

function SlideUp (props) {
  return <Slide {...props} direction='up' />
}

export default function ColorAlert ({
  open,
  type,
  label,
  onClose,
  style = {}
}) {
  const bgColor = type === 'error' ? '#EF3688' : '#000000'
  // const bgColor = type === 'error' ? '#EF3688' : 'red'

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      TransitionComponent={SlideUp}
      TransitionProps={{ timeout: 300 }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={style}
    >
      <div
        className={styles.colorAlert_root}
        style={{ backgroundColor: bgColor }}
      >
        <span className={styles.colorAlert_title}>{label}</span>
        <button onClick={onClose} className={styles.colorAlert_actionButton}>
          Ok
        </button>
      </div>
    </Snackbar>
  )
}
